module.exports = __webpack_public_path__ + "static/media/userManager.228a529d.jpg";